/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const EmployeeActiveState = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    LAID_OFF: 'LAID_OFF'
} as const;
export type EmployeeActiveState = typeof EmployeeActiveState[keyof typeof EmployeeActiveState];

